import { PaletteOptions } from '@mui/material/styles';
import tokens from '@skodaflow/web-tokens/src/tokens.json';

const generatePalette = (colorModel: 'hex' | 'rgba'): PaletteOptions => {
  const tokenColors = tokens[`flow-colors${colorModel === 'rgba' ? '-rgba' : ''}`];

  return {
    mode: 'light',
    primary: {
      main: tokenColors['brand-primary'],
      light: tokenColors['brand-hover-primary'],
      dark: tokenColors['brand-tertiary'],
    },
    secondary: {
      main: tokenColors['on-surface700'],
      light: tokenColors['on-surface600'],
      dark: tokenColors['on-surface800'],
    },
    error: {
      main: tokenColors['semantic-alert'],
      light: tokenColors['semantic-alert-tertiary'],
      dark: tokenColors['semantic-alert-secondary'],
    },
    success: {
      main: tokenColors['semantic-positive'],
      light: tokenColors['brand-quarternary'],
      dark: tokenColors['brand-tertiary'],
    },
    info: {
      main: tokenColors['semantic-info'],
      light: tokenColors['semantic-info-tertiary'],
      dark: tokenColors['semantic-info-secondary'],
    },
    warning: {
      main: tokenColors['semantic-warning'],
      light: tokenColors['semantic-warning-tertiary'],
      dark: tokenColors['semantic-warning-secondary'],
    },
    divider: tokenColors['surface-secondary'],
    brand: {
      primary: tokenColors['brand-primary'],
      secondary: tokenColors['brand-secondary'],
      tertiary: tokenColors['brand-tertiary'],
      quarternary: tokenColors['brand-quarternary'],
    },
    brandHover: {
      primary: tokenColors['brand-hover-primary'],
      secondary: tokenColors['brand-hover-secondary'],
    },
    disabled: {
      primary: tokenColors['disabled-primary'],
      secondary: tokenColors['disabled-secondary'],
      tertiary: tokenColors['disabled-tertiary'],
    },
    text: {
      primary: tokenColors['text-primary'],
      secondary: tokenColors['on-surface700'],
      disabled: tokenColors['disabled-primary'],
    },
    background: {
      primary: tokenColors['background-primary'],
      paper: tokenColors['background-primary'],
      default: tokenColors['surface-secondary'],
    },
    transparent: {
      transparent: 'transparent',
      primary: tokenColors['transparent-primary'],
      tertiary: tokenColors['transparent-tertiary'],
      quarternary: tokenColors['transparent-quarternary'],
      secondary: tokenColors['transparent-secondary'],
      backdrop: tokenColors['transparent-backdrop'],
    },
    surface: {
      main: tokenColors['surface-primary'],
      primary: tokenColors['surface-primary'],
      secondary: tokenColors['surface-secondary'],
      tertiary: tokenColors['surface-tertiary'],
      quarternary: tokenColors['surface-quarternary'],
      contrastText: tokenColors['text-primary'],
    },
    onSurface: {
      os0: tokenColors['on-surface0'],
      os100: tokenColors['on-surface100'],
      os200: tokenColors['on-surface200'],
      os300: tokenColors['on-surface300'],
      os500: tokenColors['on-surface500'],
      os600: tokenColors['on-surface600'],
      os700: tokenColors['on-surface700'],
      os800: tokenColors['on-surface800'],
      os900: tokenColors['on-surface900'],
    },
    semantic: {
      alert: {
        primary: tokenColors['semantic-alert'],
        secondary: tokenColors['semantic-alert-secondary'],
        tertiary: tokenColors['semantic-alert-tertiary'],
      },
      warning: {
        primary: tokenColors['semantic-warning'],
        secondary: tokenColors['semantic-warning-secondary'],
        tertiary: tokenColors['semantic-warning-tertiary'],
      },
      info: {
        primary: tokenColors['semantic-info'],
        secondary: tokenColors['semantic-info-secondary'],
        tertiary: tokenColors['semantic-info-tertiary'],
      },
      positive: {
        primary: tokenColors['semantic-positive'],
      },
    },
  };
};

export const paletteLight: PaletteOptions = generatePalette('hex');
export const paletteLightRGBa: PaletteOptions = generatePalette('rgba');
